import { ReserveListGenerate } from '../../../../store/api';
import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export type ApiGenerateReserveReportParams = {
    generateSettings: any;
};

export const generateReserveReport = ({ generateSettings }: ApiGenerateReserveReportParams) => {
    return http
        .post<ReserveListGenerate>(reservesConfig().endpointReserveListGenerate, generateSettings)
        .then(res => res.data);
};
